import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import styled from 'styled-components';
import type { BaseModalProps } from './BaseModal';
import BaseModal from './BaseModal';
import ModalGlobalStyles from './ModalGlobalStyles';
import { modalOpened, modalClosed } from './redux';
import CloseButton from './shared/CloseButton';

export type VideoModalProps = BaseModalProps & {
  darkMode?: boolean;
};

type DispatchProps = {
  modalOpened: () => void;
  modalClosed: () => void;
};

const mapDispatchToProps = {
  modalOpened,
  modalClosed,
};

class VideoModalWithContent extends BaseModal<VideoModalProps & DispatchProps> {
  public render() {
    const {
      isOpen = true,
      contentLabel,
      closeHandler,
      darkMode,
      children,
      ...props
    } = this.props;

    return (
      <ReactModal
        isOpen={isOpen}
        role="dialog"
        aria-modal="true"
        aria-label={contentLabel}
        className="video-modal"
        closeTimeoutMS={400}
        onAfterOpen={this.handleAfterOpen}
        onRequestClose={this.handleRequestClose}
      >
        <ModalGlobalStyles darkMode={darkMode} />
        <CloseButton
          contentLabel={contentLabel}
          onClick={this.handleRequestClose}
          darkMode={darkMode}
          {...props}
        />
        <VideoWrapper>{children}</VideoWrapper>
      </ReactModal>
    );
  }

  handleAfterOpen = () => {
    // Apply the saved scroll position to the #root element when the modal is opened
    const rootElement = document.getElementById('root')!;

    if (rootElement) {
      rootElement.scrollTop = this.savedScrollPosition;
    }
    const video = document.getElementsByClassName('modal-video')[0];
    video.addEventListener('webkitendfullscreen', this.props.closeHandler);
    this.props.openHandler && this.props.openHandler();

    this.props.modalOpened();
  };

  handleRequestClose = () => {
    const video = document.getElementsByClassName('modal-video')[0];
    video.removeEventListener('webkitendfullscreen', this.props.closeHandler);

    this.applySavedScrollPosition();
    this.props.closeHandler && this.props.closeHandler();

    this.props.modalClosed();
  };
}

const VideoWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1280px;
`;

export default connect(undefined, mapDispatchToProps)(VideoModalWithContent);
